import React, { useState, useEffect } from 'react';
import BookingCalendar from './Calendar';
import TimeSlotPicker from './TimeSlotPicker';
import { getAvailableSlots, createBooking } from '../../services/api';
import { loadStripe } from '@stripe/stripe-js';
import { createCheckoutSession } from '../../services/api';

const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY || 'pk_test_YOUR_STRIPE_PUBLISHABLE_KEY');

const BookingForm = () => {
    const [selectedDate, setSelectedDate] = useState(new Date());
    const [availableSlots, setAvailableSlots] = useState([]);
    const [selectedSlot, setSelectedSlot] = useState(null);
    const [amount, setAmount] = useState(1000); // Example amount in cents (e.g., $10.00)
    const [error, setError] = useState('');
    const [success, setSuccess] = useState('');

    useEffect(() => {
        const fetchSlots = async () => {
            setError('');
            setAvailableSlots([]);
            setSelectedSlot(null);
            try {
                const dateString = selectedDate.toISOString().split('T')[0];
                const response = await getAvailableSlots(dateString);
                setAvailableSlots(response.data);
            } catch (err) {
                setError('Failed to fetch available slots.');
                console.error(err);
            }
        };
        fetchSlots();
    }, [selectedDate]);

    const handleBookingSubmit = async () => {
        setError('');
        setSuccess('');
        if (!selectedSlot) {
            setError('Please select a time slot.');
            return;
        }

        try {
            const bookingData = {
                start_time: selectedSlot.start_time,
                end_time: selectedSlot.end_time,
                amount: amount,
            };
            const bookingResponse = await createBooking(bookingData);
            setSuccess('Booking created successfully! Redirecting to payment...');

            // Initiate Stripe Checkout
            const sessionResponse = await createCheckoutSession(bookingResponse.data.id);
            const stripe = await stripePromise;
            const result = await stripe.redirectToCheckout({
                sessionId: sessionResponse.data.id,
            });

            if (result.error) {
                setError(result.error.message);
            }
        } catch (err) {
            setError('Failed to create booking or initiate payment.');
            console.error(err);
        }
    };

    return (
        <div className="container mx-auto p-4">
            <h2 className="text-3xl font-bold mb-6 text-center">Book Your Slot</h2>
            {error && <p className="text-red-500 text-center mb-4">{error}</p>}
            {success && <p className="text-green-500 text-center mb-4">{success}</p>}

            <div className="bg-white p-6 rounded-lg shadow-md">
                <BookingCalendar selectedDate={selectedDate} onDateChange={setSelectedDate} />
                <TimeSlotPicker
                    availableSlots={availableSlots}
                    selectedSlot={selectedSlot}
                    onSlotSelect={setSelectedSlot}
                />
                <div className="mt-6 text-center">
                    <p className="text-lg font-semibold mb-4">Amount: ${amount / 100}.00</p>
                    <button
                        className="bg-blue-600 hover:bg-blue-700 text-white font-bold py-3 px-6 rounded-lg text-xl focus:outline-none focus:shadow-outline"
                        onClick={handleBookingSubmit}
                        disabled={!selectedSlot}
                    >
                        Confirm Booking & Pay
                    </button>
                </div>
            </div>
        </div>
    );
};

export default BookingForm;